<script lang="ts">
  import { IMAGE_SIZES, getCloudflareImageVariant } from '$lib/utils';
  import type { JsonValue } from '@prisma/client/runtime/library';
  import { writable } from 'svelte/store';

  export let src: string | JsonValue | undefined | null;
  export let alt: string = '';
  export let style: string = '';

  type TVariant = {
    src: string | null;
    width: (typeof IMAGE_SIZES)[number];
  };
  let variants: TVariant[] = [];
  const source = writable<string>('');

  $: if (src) {
    if (typeof src === 'string') {
      source.set(src);
    } else if (Array.isArray(src)) {
      source.set(src[0] as any);
    }

    if ($source) {
      const sortedSizes = IMAGE_SIZES.sort((a, b) => a - b);
      variants = sortedSizes.map((width) => ({
        src: getCloudflareImageVariant($source, width),
        width
      }));
    }
  }
</script>

{#if $source}
  <picture>
    {#each variants.slice().reverse() as img, index}
      {#if index < variants.length - 1}
        <source media="(min-width: {img.width + 1}px)" srcset={img.src} />
      {/if}
    {/each}
    <img src={variants[variants.length - 1].src} class={$$props.class} alt={alt ?? ''} {style} />
  </picture>
{:else}
  <img src="/assets/placeholder.jpeg" class={$$props.class} {alt} {style} />
{/if}
